import styled, { css } from 'styled-components';
import { sm, xs } from '@exonet/react-shared/lib/styled';

export const Footer = styled.footer`
  flex: 0 0 auto;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  gap: var(--sm-padding-vertical);

  padding: var(--xs-padding);
  color: var(--text);
  border-top: 1px solid var(--bg-3);
  font-size: var(--sm-font-size);

  > span {
    flex: 1 1 auto;
    padding: var(--lg-padding-vertical);
    border-top: 1px solid var(--bg-3);
  }

  ${sm(css`
    margin-bottom: inherit;
    padding: var(--sm-padding);
    flex-flow: row nowrap;
  `)}
`;

export const Info = styled.div`
  flex: 1 1 50%;
`;

export const Content = styled.div`
  :not(:last-child) {
    padding-bottom: var(--xs-padding-vertical);
  }
`;

export const Links = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-size: 13px;

  ${xs(css`
    justify-content: flex-end;
    text-align: right;
    align-self: flex-end;
    font-size: var(--font-size);
  `)}
`;

export const Link = styled.a.attrs({
  target: '_blank',
})`
  &,
  &:active,
  &:visited {
    color: var(--link);
  }

  margin: 0 var(--xs-padding-vertical);

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 20px;
  background-color: var(--text);
`;
